import {useCallback} from "react";
import {apiEndpoint, useUser} from "@/components/Providers/JWTProvider.tsx";

const useConfirmFab = (): ((
    courseSectionIds: string[],
    cartId?: string,
) => Promise<Response | void>) => {
    const {user} = useUser();

    return useCallback(
        async (courseSectionIds: string[], cartId?: string): Promise<Response | void> => {
            const url = new URL("/v1/payment/confirm-fab", apiEndpoint);

            if (!user) {
                console.error("missing user");
                return;
            }

            const init: RequestInit = {method: "POST"};
            init.body = JSON.stringify({
                courseSectionIds: courseSectionIds,
                cartId: cartId,
            });

            return await user.apiFetch(url.toString(), init);
        },
        [user],
    );
};

export default useConfirmFab;